export default __webpack_public_path__ + "static/media/lover-icon.f995ff91.svg";